// extracted by mini-css-extract-plugin
export var wordContainer = "_qe-0";